import $ from "jquery";

import * as types from '../actions/actionTypes';
import {LOOK_OVERLAYS} from "../bvcomponents/look/core/constants";

const initialState = {
  showUnlockCalculations: false,
  unlockCalculationsStep: 0,
  showCartItems: [],
  showTotalItems: [], // "tax", "total"
  showUnlockCalculationsTutorial: false,
  unlockCalculationsTutorialIsFinished: false,
  unlockCalculationsTutorialStep: 0,
};

export default function(state = initialState, action) {

  switch(action.type) {

    case types.SET_SHOW_UNLOCK_CALCULATIONS:
    case types.SET_UNLOCK_CALCULATIONS_STEP:
    case types.SHOW_UNLOCK_CALCULATIONS_CART_ITEM:
    case types.SHOW_UNLOCK_CALCULATIONS_TOTAL_ITEM:
    case types.SHOW_UNLOCK_CALCULATIONS_TUTORIAL:
    case types.SET_UNLOCK_CALCULATIONS_TUTORIAL_STEP:
    case types.SET_UNLOCK_CALCULATIONS_TUTORIAL_FINISHED:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.SET_LOOK_OVERLAY_OPENED:
      if ((action.payload.lookOverlayOpened === LOOK_OVERLAYS.leadCapture) && state.showUnlockCalculations && (state.unlockCalculationsStep !== 4)) {
        const overlayElement = document.querySelector(".look-overlay--style");
        if (overlayElement) {
          $(overlayElement).fadeIn(300);
        }
        return Object.assign({}, state, {
          unlockCalculationsStep: 4
        });
      }
  }

  return state;

}
